import logger from '../utilities/logger'
import ConfigService, { tenant } from './ConfigService'
import chapiClient from '../utilities/chapiClient'


chapiClient.init(
  ConfigService.chapiBaseUrl(),
  ConfigService.chapiAuthMode(),
  tenant
)

export default {
  getArticles() {
    const helpArticles = window.document.getElementById('helpArticles')
    if (helpArticles && helpArticles.href) {
      return fetch(helpArticles.href)
        .then(response => response.json())
        .catch(e => {
          logger.error('Get articles failed', e)
          throw e
        })
    }
    return logger.error('Get articles failed - url not provided')
  },
  getArticleData(articleId, orderId) {
    return chapiClient.getArticleData(articleId, orderId)
  },
  createSupportRequest(orderId, reason, body) {
    return chapiClient.createSupportRequest(orderId, reason, body)
      .catch(e => {
        logger.error('Create support request failed', e)
        // This needs to throw for the form to update
        throw new Error(`POST: Email contact failed! ${e}`)
      })
  },
  createQuerySupportRequest(orderId, queryType, body) {
    return chapiClient.createQuerySupportRequest(orderId, queryType, body)
  },
  getChatSupportToken() {
    return chapiClient.getChatSupportToken()
  },
  getContentConcernForm(routeQueries) {
    return chapiClient.getContentConcernForm(routeQueries)
  },
  reportContentConcern(formData) {
    return chapiClient.reportContentConcern(formData)
  },
  getFooterContent() {
    const footerContent = window.document.getElementById('footerContent')
    if (footerContent && footerContent.href) {
      return fetch(footerContent.href)
        .then(response => response.json())
        .catch(e => {
          logger.error('Get footer content failed', e)
          throw e
        })
    }
    return logger.error('Get footer content failed - url not provided')
  }
}
